
export const FETCH_DIAGNOSTICS = 'FETCH_DIAGNOSTICS';
export const FETCH_DIAGNOSTICS_SUCCESS = 'FETCH_DIAGNOSTICS_SUCCESS';
export const FETCH_DIAGNOSTICS_FAILED = 'FETCH_DIAGNOSTICS_FAILED';

export const FETCH_DIAGNOSTICS_DETAILS = 'FETCH_DIAGNOSTICS_DETAILS';
export const FETCH_DIAGNOSTICS_DETAILS_SUCCESS = 'FETCH_DIAGNOSTICS_DETAILS_SUCCESS';
export const FETCH_DIAGNOSTICS_DETAILS_FAILED = 'FETCH_DIAGNOSTICS_DETAILS_FAILED';
